import { Link } from "react-router-dom";
import "../styles/home.css";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
// import FlashSaleSection from "../components/FlashSaleSection";
import CategorySlider from "../components/CategorySlider";
import ProductCard from "../components/ProductCard";
import SEO from "../components/SEO";
import { getOrganizationSchema } from "../utils/schema";
import Loader from "../components/Loader";
const Home = () => {
  const [banners, setBanners] = useState([]);
  const [current, setCurrent] = useState(0);
   const [products, setProducts] = useState([]);
 const [loading, setLoading] = useState(true);
  const API_URL = process.env.REACT_APP_API_URL;

  /* =============================
        FETCH BANNERS
  ============================= */
const premiumRef = useRef();
const [isMobile, setIsMobile] = useState(
  window.innerWidth <= 768
);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  window.addEventListener("resize", handleResize);

  return () =>
    window.removeEventListener(
      "resize",
      handleResize
    );
}, []);

useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        }
      });
    },
    { threshold: 0.3 }
  );

  if (premiumRef.current) {
    observer.observe(premiumRef.current);
  }

  return () => observer.disconnect();
}, []);


useEffect(() => {

  const fetchData = async () => {

    try {

      const [bannerRes, productRes] = await Promise.all([

        axios.get(`${API_URL}/api/banners`),

        axios.get(`${API_URL}/api/products/featured`),
        

      ]);

      setBanners(bannerRes.data || []);

      setProducts(productRes.data || []);
      

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }

    

  };

  fetchData();

}, [API_URL]);


  /* =============================
        AUTO SLIDER
  ============================= */

  useEffect(() => {
    if (banners.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev === banners.length - 1 ? 0 : prev + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [banners]);

  const nextSlide = () => {
    setCurrent((prev) =>
      prev === banners.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? banners.length - 1 : prev - 1
    );
  };

  if (loading) {
  return <Loader />;
}


  return (
    
    
    <div className="home-page">
    <SEO
        schema={getOrganizationSchema()}
      />

      {/* ================= HERO SLIDER ================= */}

      {banners.length > 0 && (
        <section className="hero-slider">

          {banners.map((banner, index) => (
            <div
             key={`${banner._id}-${index}`}
              className={`slide ${
                index === current ? "active" : ""
              }`}
            >
            <img
    src={
      isMobile
        ? banner.mobileImage
        : banner.desktopImage
    }

    alt={banner.title}

    style={{
      objectPosition:
        isMobile
          ? "center"
          : banner.desktopPosition || "center",
    }}
/>
              <div className="hero-content">
                <h1>{banner.title}</h1>

                {banner.subtitle && (
                  <p>{banner.subtitle}</p>
                )}
                <h2 >{banner.description}</h2>

                <Link
                  to="/products"
                  className="hero-btn"
                >
                  Explore Collection
                </Link>
              </div>
            </div>
          ))}

          {/* Arrows */}
          <button className="arrow left" onClick={prevSlide}>
            ❮
          </button>

          <button className="arrow right" onClick={nextSlide}>
            ❯
          </button>

        </section>
      )}



      <div className="feature-bar">
  <div className="feature-item">
    <i className="ri-shield-check-line"></i>
    <span>Quality & Affordability : Our Promise</span>
  </div>
  <div className="feature-item">
    <i className="ri-truck-line"></i>
    <span>Fast Pan-India Delivery</span>
  </div>
  <div className="feature-item">
    <i className="ri-refresh-line"></i>
    <span>Easy Returns & Exchanges</span>
  </div>
</div>

{/* 
  <FlashSaleSection /> */}


      {/* ================= CATEGORY SECTION ================= */}
      <CategorySlider />

        <section className="featured-section">
        <h2>FEATURED PRODUCTS</h2>

      <div className="products-grid featured-grid">
  {products.map((item) => (
    <ProductCard
      key={item._id}
      product={item}
      openCart={() => {}}
    />
  ))}
</div>

      </section>

      {/* ================= FLASH SALE ================= */}
    

      {/* ================= PREMIUM BRAND SECTION ================= */}

    <section className="premium-hero" ref={premiumRef}>
        <div className="container hero-container">

          {/* LEFT SIDE */}
          <div className="hero-left">
            <h1>
              Welcome to <span>Soft Strides</span>
            </h1>

            <p>
              Discover premium oversized T-shirts crafted from high-quality cotton, designed for everyday comfort and bold self-expression.
              Designed for everyday confidence.
            </p>

            <Link
              to="/products"
              className="hero-cta-btn"
            >
              Shop Collection →
            </Link>
          </div>

          {/* RIGHT SIDE FEATURES */}
          <div className="hero-right">

            <div className="hero-feature-card">
              <div className="hero-feature-icon">✓</div>
              <h3>Premium Materials</h3>
              <p>
                High-quality fabrics built for
                durability and comfort.
              </p>
            </div>

            <div className="hero-feature-card">
              <div className="hero-feature-icon">🔥</div>
              <h3>Modern Designs</h3>
              <p>
                Trend-driven styles for every
                occasion and season.
              </p>
            </div>

            <div className="hero-feature-card">
              <div className="hero-feature-icon">💳</div>
              <h3>Secure Payments</h3>
              <p>
                Encrypted and protected checkout
                experience.
              </p>
            </div>

            <div className="hero-feature-card">
              <div className="hero-feature-icon">🔁</div>
              <h3>Easy Returns</h3>
              <p>
                Hassle-free exchange and refund
                process.
              </p>
            </div>

          </div>

        </div>
      </section>

    </div>
  );
};

export default Home;
